/** @jsx jsx */
import { Fragment } from 'react'
import { Link } from 'gatsby'
import { Button, Flex, jsx, Text } from 'theme-ui'
import CloseIcon from '~/assets/images/icons/close.inline.svg'
import { useReferrals } from '~/hooks/components/use-referrals'
import useUiTextQuery from '~/hooks/graphql/queries/use-ui-text'

const ReferralsButton = () => {
  const {
    referralsHasHiddenBubble,
    referralsHasPurchased,
    setReferralsHasHiddenBubble,
  } = useReferrals()
  const referralsUiText = useUiTextQuery('global', 'referrals')

  const HideAttentiveStyles = (
    <style>{`#attentive_overlay { display: none !important }`}</style>
  )

  if (!referralsHasPurchased) {
    return <Fragment />
  }

  if (referralsHasHiddenBubble) {
    return HideAttentiveStyles
  }

  return (
    <Flex
      bg="brandPrimary"
      sx={{
        borderRadius: '2px',
        bottom: '24px',
        position: 'fixed',
        right: '24px',
        zIndex: '90',
      }}
    >
      <Link
        to={'/refer-a-friend/'}
        sx={{
          color: 'white',
          display: 'block',
          fontWeight: 'bold',
          pb: '9px',
          pl: 2,
          pr: 1,
          pt: '3px',
          textDecoration: 'none',
          textTransform: 'uppercase',
        }}
      >
        <Text as="span" variant="body2">
          {referralsUiText.button}
        </Text>
      </Link>
      <Button
        variant="reset"
        pl={1}
        pr={2}
        onClick={() => setReferralsHasHiddenBubble(true)}
      >
        <CloseIcon color="white" sx={{ height: '16px', width: '16px' }} />
      </Button>
      {HideAttentiveStyles}
    </Flex>
  )
}

export default ReferralsButton
